/* global axios */
import ApiClient from '../ApiClient';

class NexceoProjectGoogleSyncAPI extends ApiClient {
  constructor() {
    super('nexceo/projects', { accountScoped: true });
  }

  show(projectId) {
    return axios.get(`${this.url}/${projectId}/google_sync`);
  }

  retry(projectId) {
    return axios.post(`${this.url}/${projectId}/google_sync/retry`);
  }
}

export default new NexceoProjectGoogleSyncAPI();
